import {useEffect, useState} from "react";
import {useQuery} from "react-query";
import Blocks from "../blocks";
import Partials from "../partials";
import ConferenceImage from "../../assets/images/group-discussion.png";
import {getAllStudentsOfVirtualClass, getAllStudentsOfVirtualClassRTQ} from "../../api/students";
import {useHistory, useParams} from "react-router-dom";

const PageStudentInvite = () => {
    const [inviteSent, _setInviteSent] = useState(0);
    const params = useParams();
    const history = useHistory();
    const classId = params.classId;

    useEffect(() => {
        if (!classId) {
            history.replace("/create-virtual-class")
        }
    });

    /** get class details */
    const {
        isLoading,
        isError,
        data,
        error
    } = useQuery(['getAllStudentsOfVirtualClass', {classId}], getAllStudentsOfVirtualClassRTQ, {
        classId
    });

    const students = Array.isArray(data?.data?.body) ? data.data.body : [];

    return (
        <div className={'page PageStudentInvite'}>
            <div className="container mx-auto">
                {!inviteSent &&
                    <h3 className={"block md:hidden text-xl text-center pt-16 pb-4 font-['Poppins-Bold']"}>Student
                        Invite</h3>}
                <div className="flex flex-col md:flex-row items-center">
                    <div className="bgWrapper flex justify-center items-center bg-white">
                        <img src={ConferenceImage} alt="bg-class-image max-h-8 md:max-h-16"/>
                    </div>
                    <div
                        className="pageContent w-full max-w-lg mx-auto md:mr-0 md:ml-auto  mb-4 bg-white p-4 rounded-xl">
                        <Blocks.ErrorBoundary>
                            {
                                !inviteSent ?
                                    <>
                                        <h1 className={'hidden md:block mb-4 text-4xl font-heading'}>Student invite</h1>

                                        {
                                            isLoading ?
                                                <Partials.PartialLoading classes={"text-zinc-800 -h-10 -w-10"}/>
                                                :
                                                <Blocks.BlockClassInvite students={students}
                                                                         onInviteSuccess={(invited) => _setInviteSent(invited)}/>
                                        }

                                    </>
                                    :
                                    <div>
                                        <h3 className={"text-4xl text-center mb-10 font-['Poppins-Bold'] hidden md:block"}>Invited
                                            Successfully</h3>
                                        <Partials.PartialSuccessIcon/>
                                        <h3 className={"text-2xl text-center mb-10 font-['Poppins-Bold'] block md:hidden"}>Invited
                                            Successfully</h3>
                                        <p className={"text-xl text-center leading-loose mb-10"}>Invite Sent to {inviteSent} student{inviteSent !== 1 ? 's' : ''} via email</p>
                                        <div className={"flex justify-center"}>
                                            <button
                                                onClick={() => history.push(`/teacher/start-live-class`)}
                                                className="w-full md:w-min bg-black hover:bg-slate-600 text-white font-bold py-3 px-4 rounded focus:outline-none focus:shadow-outline">
                                                OK
                                            </button>
                                        </div>
                                    </div>
                            }
                        </Blocks.ErrorBoundary>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PageStudentInvite;
